import type { IGetOfficeConsentParameters } from '../../types/OfficeConsent.parameters';

export const factoryGetOfficeConsentKey = (params: IGetOfficeConsentParameters) => {
  return ['GET_OFFICE_CONSENT', params.officeId, params.code] as const;
};
